import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from "interfaces/paginate-duck";
import { Justification } from "interfaces/justification";

const { Types, Creators } = createActions(
  {
    request: ["query"],
    success: ["data", "pagination"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "PAGINATE_JUSTIFICATION_" }
);

export interface PaginateJustificationsState extends IState {
  data: Justification[];
}

const INITIAL_STATE: PaginateJustificationsState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: PaginateJustificationsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: PaginateJustificationsState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data as Justification[] },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (state: PaginateJustificationsState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const paginateJustifications = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginateJustificationsTypes = Types;
export const PaginateJustificationsActions = Creators;
